<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-progress-circular
            :size="80"
            color="primary"
            width="3"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$t("security.logout.title"),
    };
  },
  created() {
    this.logout();
  },
  methods: {
    async logout() {
      try {
        await this.$auth.logout();
      } catch (error) {
        // empty
        console.log(error);
      }
    },
  },
};
</script>

